import styled from "styled-components";

import { Flex } from "./Flex";
import { Spinner } from "./Spinner";
import { ThemeType } from "../theme/Theme";

const Container = styled(Flex)<{
  containerHeight?: React.CSSProperties["height"];
}>`
  justify-content: center;
  align-items: center;
  height: ${({ containerHeight }) => containerHeight};
  width: 100%;
`;

type SpinnerFullScreenProps = {
  containerHeight?: React.CSSProperties["height"];
  color?: keyof ThemeType;
};

export const SpinnerFullScreen: React.FC<SpinnerFullScreenProps> = ({
  containerHeight = "90vh",
  color = "main",
}) => {
  return (
    <Container containerHeight={containerHeight}>
      <Flex width={"3rem"} height={"3rem"}>
        <Spinner color={color} />
      </Flex>
    </Container>
  );
};
